module.exports = __webpack_public_path__ + "img/MEDIA023.defa7241.jpg";